import React, { useEffect, forwardRef, useImperativeHandle, useState, useRef, useContext } from "react";
import {
  SettingOutlined,
  LoginOutlined,
  UserOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import {
  Dropdown,
  Layout,
  Menu,
  MenuProps,
  theme,
  Modal,
  App,
  Button,
  Tabs,
  Input,
  Tree,
  message,
  Spin,
  Form,
  Image,
  Upload,
  Select,
  Divider,
  notification,
  InputNumber,
  Col,
  Row,
  Flex
} from "antd";
import _, { forEach } from "lodash";

import { LayoutWrap, ProfileItem, ModalWrap } from "./style";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ROUTER_KEYS } from "@/router/routers";
import WMSAvatar from "@/styles/WMSAvatar";
import { getUserAvatarTip, hasPermission } from "@/utils/user";
import profileLogout from "@/pages/Profile/utils/logout";
import useOrg from "@/pages/OrgManager/hooks/useOrgDetail";
import { UserDetailEdit } from "@/components/UserEdit";
import { Org } from "@/types/org";
import { User, UserPermissionEnum } from "@/types/user";
import { OrgsContext } from "./context/OrgsContext";
import type { TreeDataNode, TreeProps } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "@/store/index";
import { setCurOrg } from "@/store/modules/orgReducer";
import useSwitchOrgs from "./hooks/useSwitchOrgs";
import { setStorage, getStorage } from '@/utils/storage';
import { useTranslation } from 'react-i18next';
import Locale from "./components/Locale";
import useOrgList from "@/pages/OrgManager/hooks/useOrgList";
import { OrgAddModal } from "@/components/OrgAddModal";
import SOrgSelect from "@/components/SOrgSelect";
import { isNumber } from "lodash";
import errorCodes from "@/apis/error";
import SText from "@/styles/SText";
import useCategories from "./hooks/useCategories";
import { newList, set } from "@/apis/dict";
import { CustomWindow } from "@/types/common";
import useNav, { NavTitle } from "./hooks/useNav";
import { upload } from "@/utils/file/upload";
import type { GetProps, UploadFile, UploadProps, GetProp } from 'antd';
import { getFileUrl } from "apis/file";
import { currencyTypes } from '@/apis/customer';
import AddressManage from "./components/AddressManage";
import { DictContext } from "../context/DictContext";
import ReimburseCategory from "./components/ReimburseCategory";
import ApproveTemplate from "./components/ApproveTemplate";
import PurchaseRules from "./components/PurchaseRules";
import { initPrintSetting } from "./utils";

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

type DirectoryTreeProps = GetProps<typeof Tree.DirectoryTree>;
const { Content, Sider } = Layout;
const { confirm } = Modal;

const { Search } = Input;
interface TreeSelectData extends Org {
  disabled?: boolean
}

interface FormRef {
  submit: () => void;
}

const HomeLayout: React.FC = () => {
  const navigate = useNavigate();
  const { notification } = App.useApp();
  const { t } = useTranslation();
  const routerLocation = useLocation();
  const stateDispatch: AppDispatch = useDispatch();
  const currentOrg: Org = useSelector((state: RootState) => state.orgReducer.curOrg);
  const currentUser: User = useSelector((state: RootState) => state.userReducer.curUser);

  const treeRef = useRef<FormRef>(null)
  const printRef = useRef<FormRef>(null)
  const currencyRef = useRef<FormRef>(null)
  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
  const [, , , { fetch }] = useOrg();

  const [menuSelectKeys, setMenuSelectKeys] = useState("");
  const [menuOpenKeys, setMenuOpenKeys] = useState<string[]>([
    ROUTER_KEYS.SALES_CUSTOMER
  ]);
  const [keyPath] = useState<Array<{ title: string }>>([]);
  const [isUserInfo, setIsUserInfo] = useState(false);
  const [selectValue, setSelectValue] = useState<string>(currentOrg.id);
  const [openAddOrg, setOpenAddOrg] = useState<boolean>(false);
  const { exchangeRate, setExchangeRate, printSetting, setPrintSetting } = useContext(DictContext);


  const [orgsList, , , { add }] = useOrgList({});
  const [orgs, actions] = useSwitchOrgs(hasPermission(currentUser, [UserPermissionEnum.ADMIN]) ? orgsList : currentUser.orgs);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeKey, setActiveKey] = useState<string>('1')
  const [loading, setLoading] = useState(false)
  const [isTooltipOpen, setIsTooltipOpen] = useState(false) // 控制用户头像Tip是否显示
  const [
    listTree,
    ,
    loadingTree,
    { addCategory, updateCategory, deleteCategory, searchCategory },
  ] = useCategories({ keyword: "" });
  useEffect(() => {
    setSelectValue(currentOrg.id);
  }, [currentOrg]);

  useEffect(() => {
    setMenuSelectKeys(routerLocation.pathname + window.decodeURI(routerLocation.search));
  }, [routerLocation.pathname, routerLocation.search]);


  const menuNavTitles = useNav()

  const setIds = (arr: Array<any>) => {
    listTree.forEach(item => {
      arr.push(item)
      if (item.subs.length) {
        item.subs.forEach(data => {
          arr.push(data)
          if (data.subs.length) {
            data.subs.forEach(value => [
              arr.push(value)
            ])
          }
        })
      }
    })
  }


  const treeSelectChange = async (value: string) => {
    if (value && value.includes('Null_')) {
      notification.warning({ placement: 'top', message: t('layout.switchOrgFailTip1') })
      return
    }
    if (value !== currentOrg.id) {
      try {
        const checkOrgInfo = await fetch(value)
        if (checkOrgInfo) {
          stateDispatch(setCurOrg(checkOrgInfo))
          setSelectValue(checkOrgInfo.id)
          setStorage('curOrgId', checkOrgInfo.id)
          setStorageAccount(checkOrgInfo.id)
          notification.success({ placement: 'top', message: t('layout.switchOrg'), duration: 1.5 })
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          notification.warning({ placement: 'top', message: t('layout.switchOrgFailTip2') })
        }
      } catch (error) {
        const description = isNumber(error)
          ? errorCodes[error]
          : error instanceof Error
            ? error.message
            : String(error)
        notification.warning({ placement: 'top', message: t('org.orgFetchFail'), description });
      }
    }
  };

  const setStorageAccount = (nowOrgId: string) => {
    const accountStorage = getStorage('account')
    if (!Array.isArray(accountStorage)) return

    const nextAccountStorage = accountStorage.map(account =>
      account.mobile === currentUser.mobile
        ? { ...account, loginOrgId: nowOrgId }
        : account
    )
    setStorage('account', nextAccountStorage)
  }


  const submit = () => {
    if (activeKey === '1') {
      if (printRef && printRef.current) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        printRef.current.submit();
      }
    } else if (activeKey === '2') {
      if (treeRef && treeRef.current) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        treeRef.current.submit();
      }
    } else {
      if (currencyRef && currencyRef.current) {
        currencyRef.current.submit();
      }
    }
  }

  const showConfirm = (fun: any) => {
    confirm({
      title: t("common.tip"),
      content: t("common.sure"),
      icon: <ExclamationCircleOutlined />,
      okText: t("purchase.ok"),
      cancelText: t("purchase.cancel"),
      cancelButtonProps: { style: { color: 'black', fontSize: 14, height: 24 } },
      okButtonProps: { style: { color: 'white', fontSize: 14, height: 24, background: '#7a294f' } },
      onOk() {
        fun()
      },
    });
  }

  const SetCurrency = forwardRef<FormRef>((props, ref) => {
    const [dataList, setDataList] = useState<Array<any>>([])
    const [form] = Form.useForm()
    const [currencyList, setCurrencyList] = useState<any>([])
    const [currency, setCurrency] = useState<string>('CNY')
    useEffect(() => {
      setLoading(true)
      currencyTypes().then(res => {
        setCurrencyList(res)
        const arr: any = [];
        res.forEach(item => {
          arr.push({
            label: item.desc,
            value: item.desc,
            key: item.key,
          })
        })
        setDataList(arr)
        form.setFieldValue('CNY', '1')
        // newList('EXCHANGE_RATE').then(data => {
        const obj: any = {}
        exchangeRate.forEach(item => {
          res.forEach(d => {
            if (item.key == d.key) {
              obj[d.desc] = item.value
              if (item.desc === 'mainCurrency') {
                setCurrency(d.desc)
              }
            }
          })
        })
        form.setFieldsValue(obj)
        setLoading(false)
      })
    }, [])

    const onChange = (e: any) => {
      form.resetFields();
      form.setFieldValue(e, 10000)
      setCurrency(e)
    }

    useImperativeHandle(ref, () => ({
      submit: () => {
        showConfirm(() => {
          form.validateFields().then(res => {
            setLoading(true)
            const param = []
            for (let key in res) {
              const obj = {
                key: '',
                value: res[key],
                desc: currency === key ? 'mainCurrency' : ''
              }
              currencyList.forEach((item: any) => {
                if (item.desc === key) {
                  obj.key = item.key
                }
              })
              param.push(obj)
            }
            return set('EXCHANGE_RATE', param).then(res => {
              setLoading(false)
              setIsModalOpen(false)
              setActiveKey('1')
              if (res?.length > 0) {
                setExchangeRate([...res])
              }
              notification.success({ placement: 'top', message: t("common.saveOk"), duration: 3 });
            })
          }).catch(err => {
            console.log('err', err)
            notification.error({ placement: 'top', message: t("common.saveFAil"), duration: 3 });
          }).finally(() => {
            setLoading(false)
          })
        })
      }
    }))

    return (
      <>
        <span>{t("layout.mainCurrency")}:</span>
        <Select
          style={{ width: 200 }}
          value={currency}
          options={
            dataList
          }
          onChange={onChange}
        />
        <Divider />
        <Form form={form}>
          <Row gutter={24}>
            {dataList.map((item: any) => {
              return (
                <Col span={12}>
                  <Form.Item label={item.label} name={item.label} key={item.key} rules={[{ required: true, message: t('layout.pleaseFillRate') }]}>
                    <InputNumber changeOnWheel disabled={currency === item.label} min={0} />
                  </Form.Item>
                </Col>
              )
            })}
          </Row>
        </Form>
      </>
    )
  })

  const TreeList = forwardRef<FormRef>((props, ref) => {
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    const [ids, setIdsArr] = useState<any>([]);
    useEffect(() => {
      setLoading(true)
      isModalOpen && newList('SUPPLER_PRICE_PRODUCT_CATEGORIES').then(res => {
        const arr: any = []
        res.map(item => {
          arr.push(item.value)
        })
        setCheckedKeys(arr)
        setExpandedKeys(arr)
        setLoading(false)
      }).catch(err => {
        console.log('err', err)
      }).finally(() => {
        setLoading(false)
      })
      const idArr: any = []
      setIds(idArr)
      setIdsArr(idArr)
    }, [])
    const onCheck: TreeProps['onCheck'] = (checkedKeysValue) => {
      setCheckedKeys(checkedKeysValue as React.Key[]);
    };
    const onExpand: DirectoryTreeProps['onExpand'] = (keys, info) => {
      setExpandedKeys(keys)
    };
    useImperativeHandle(ref, () => ({
      submit: () => {
        showConfirm(() => {
          setLoading(true)
          const param: any = []
          ids.forEach((item: any) => {
            checkedKeys.forEach(d => {
              if (item.id === d) {
                param.push({
                  value: item.id,
                  key: item.id,
                  desc: item.desc
                })
              }
            })
          })
          return set('SUPPLER_PRICE_PRODUCT_CATEGORIES', param).then(res => {
            setLoading(false)
            setIsModalOpen(false)
            setActiveKey('1')
            notification.success({ placement: 'top', message: t("common.saveOk"), duration: 3 });
          }).catch(err => {
            console.log('err', err)
            notification.error({ placement: 'top', message: t("common.saveFAil"), duration: 3 });
          }).finally(() => {
            setLoading(false)
          })
        })
      }
    }))


    return (
      <>
        <Search
          placeholder={t("category.plEnterName")}
          allowClear
          onSearch={(val) => searchCategory(val)}
          style={{ width: "100%", marginBottom: 10 }}
        />
        <Tree
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={false}
          checkedKeys={checkedKeys}
          checkable={true}
          onCheck={onCheck}
          key={'id'}
          blockNode
          titleRender={(data) => (
            <SText text={(data as unknown as { name: string }).name} />
          )}
          treeData={listTree as unknown as Array<any>}
          fieldNames={{ title: "name", key: "id", children: "subs" }}
          className="left-tree"
        />
      </>
    )
  })

  const PrintSetting = forwardRef<FormRef>((props, ref) => {
    // const [avatar, setAvatar] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [location, setLocation] = useState<string>('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<any[]>([]);
    const [width, setWidth] = useState<number>(0);
    const [height, setHeight] = useState<number>(0);
    const [form] = Form.useForm()
    useEffect(() => {
      if (isModalOpen) {
        let name: any
        let location: any
        let logo: any
        printSetting.map(item => {
          if (item.key === "companyName") {
            name = item.value
          }
          if (item.key === "companyLocation") {
            location = item.value
          }
          if (item.key === "companyLogo") {
            logo = item.value
            // setAvatar(item.value)
            setFileList([
              {
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: getFileUrl(item.value)
              }
            ])
          }
          form.setFieldsValue({ name, location, logo })
          setLoading(false)
        })
      }
      setLoading(false);
      let { width: w, height: h } = initPrintSetting();
      setWidth(w);
      setHeight(h);
    }, [])
    const getBase64 = (file: FileType): Promise<string> =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });

    const handlePreview = async (file: UploadFile) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj as FileType);
      }

      setPreviewImage(file.url || (file.preview as string));
      setPreviewOpen(true);
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
      setFileList(newFileList);

      if (newFileList.length) {
        // @ts-ignore
        upload({ name: newFileList[0].name, size: newFileList[0].size, file: newFileList[0].originFileObj })
          .then(uploadedFile => {
            form.setFieldValue('logo', uploadedFile && uploadedFile.id)
          })
          .finally(() => setLoading(false))
      }
    }

    useImperativeHandle(ref, () => ({
      submit: () => {
        showConfirm(() => {
          form.validateFields().then(res => {
            setLoading(true)
            localStorage.setItem("printWidth", width + '');
            localStorage.setItem("printHeight", height + '');
            const param = [{
              value: res.logo,
              key: 'companyLogo',
              desc: ''
            }, {
              value: res.location,
              key: 'companyLocation',
              desc: ''
            }, {
              value: res.name,
              key: 'companyName',
              desc: ''
            }]
            return set('PRINT_SETTING', param)
              .then(res => {
                setLoading(false)
                setIsModalOpen(false)
                setActiveKey('1')
                notification.success({ placement: 'top', message: t("common.saveOk"), duration: 3 });
                if (res?.length > 0) setPrintSetting([...res])
              })
          }).catch(err => {
            notification.error({ placement: 'top', message: t("common.saveFAil"), duration: 3 });
            console.log('err', err)
          }).finally(() => {
            setLoading(false)
          })
        })
      }
    }))
    return (
      <Form form={form} style={{ marginTop: 16 }} name="user" autoComplete="off" >
        <Form.Item label={'logo'} name="logo">
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
          >
            {fileList.length >= 1 ? null : (
              <button style={{ border: 0, background: 'none' }} type="button">
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>{t('layout.uploadImage')}</div>
              </button>
            )}
          </Upload>
          {previewImage && (
            <Image
              wrapperStyle={{ display: 'none' }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(''),
              }}
              src={previewImage}
            />
          )}
        </Form.Item>
        <Form.Item label={t('layout.company')} name="name" rules={[{ max: 100, message: t('layout.plzCompany') }]}>
          <Input value={name} onChange={(e) => setName(e.target.value)} count={{ show: true, max: 100 }} placeholder={t('layout.pleaseEnterName')} />
        </Form.Item>

        <Form.Item label={t('layout.address')} name="location" rules={[{ max: 100, message: t('layout.plzAddress') }]}>
          <Input value={location} onChange={(e) => setLocation(e.target.value)} count={{ show: true, max: 100 }} placeholder={t('layout.pleaseEnterAddress')} />
        </Form.Item>

        <Form.Item label={t('layout.printTipVertical')} >
          <Flex gap={4} align="center" >
            <InputNumber changeOnWheel style={{ width: 120 }} value={width} onChange={(val) => setWidth(val || 1)} precision={0} min={1} suffix="mm" placeholder={t('layout.width')} />
            <span>X</span>
            <InputNumber changeOnWheel style={{ width: 120 }} value={height} onChange={(val) => setHeight(val || 1)} precision={0} min={1} suffix="mm" placeholder={t('layout.height')} />
          </Flex>
        </Form.Item>
      </Form>
    )
  })

  const tabList: Array<{ label: React.ReactNode; key: string; disabled?: boolean; children?: React.ReactNode }> = [];
  if (hasPermission(currentUser, [UserPermissionEnum.SETTINGS_PRINTING])) {
    tabList.push({
      label: t('layout.printSetting'),
      key: '1',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.SETTINGS_PRINTING]),
      children: <PrintSetting ref={printRef} />,
    });
  }
  if (hasPermission(currentUser, [UserPermissionEnum.SETTINGS_QUO_TYPE])) {
    tabList.push({
      label: t('layout.typeManage'),
      key: '2',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.SETTINGS_QUO_TYPE]),
      children: <TreeList ref={treeRef} />,
    });
  }
  if (hasPermission(currentUser, [UserPermissionEnum.SETTINGS_CURR])) {
    tabList.push({
      label: t('layout.setExchange'),
      key: '3',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.SETTINGS_CURR]),
      children: <SetCurrency ref={currencyRef} />,
    });
  }
  if (hasPermission(currentUser, [UserPermissionEnum.SETTINGS_ADDRESS])) {
    tabList.push({
      label: t('layout.addressM'),
      key: '4',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.SETTINGS_ADDRESS]),
      children: <AddressManage />,
    });
  }
  if (hasPermission(currentUser, [UserPermissionEnum.REIMBUERSE_CATEGORY])) {
    tabList.push({
      label: t('layout.reimburseCategory'),
      key: '5',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.REIMBUERSE_CATEGORY]),
      children: <ReimburseCategory activeKey={activeKey} />,
    });
  }
  if (hasPermission(currentUser, [UserPermissionEnum.APPROVE_TEMPLATE_SET])) {
    tabList.push({
      label: t('layout.approveTemplate'),
      key: '6',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.APPROVE_TEMPLATE_SET]),
      children: <ApproveTemplate activeKey={activeKey} />,
    });
  }
  if (hasPermission(currentUser, [UserPermissionEnum.PRINT_RULE_SETTING])) {
    tabList.push({
      label: t('layout.purchaseRuleSet'),
      key: '7',
      disabled: !hasPermission(currentUser, [UserPermissionEnum.PRINT_RULE_SETTING]),
      children: <PurchaseRules />,
    });
  }

  const profileItems: MenuProps['items'] = [];
  profileItems.push({
    key: "userInfo",
    label: (
      <ProfileItem>
        <UserOutlined />
        <span className="txt">{t('layout.userInfo')}</span>
      </ProfileItem>
    ),
    onClick: () => setIsUserInfo(true),
  });

  if (hasPermission(currentUser, [UserPermissionEnum.SETTINGS_CURR, UserPermissionEnum.SETTINGS_PRINTING, UserPermissionEnum.SETTINGS_QUO_TYPE, UserPermissionEnum.SETTINGS_ADDRESS])) {
    profileItems.push({
      key: "settings",
      label: (
        <ProfileItem>
          <SettingOutlined />
          <span className="txt">{t('layout.preferences')}</span>
        </ProfileItem>
      ),
      onClick: () => {
        setIsModalOpen(true)
        // setLoading(true)
      },
    });
  }

  profileItems.push({
    key: "logout",
    label: (
      <ProfileItem>
        <LoginOutlined />
        <span className="txt">{t('layout.logout')}</span>
      </ProfileItem>
    ),
    onClick: () => exitLoginHandle(),
  });

  const exitLoginHandle = () => {
    confirm({
      title: t('layout.conLogout'),
      content: t('layout.conLogoutTip1'),
      onOk() {
        notification.success({ placement: 'top', message: t('layout.loggingOut'), duration: 1 });
        setTimeout(() => {
          profileLogout();
        }, 200);
      },
    });
  };

  const treeTitleRender = (data: Org | string) => {
    if (typeof data === 'string') return
    if (_.size(data) > 1) {
      return <div style={data.id.includes('Null_')
        ? { width: '60px', height: '20px', border: '2px solid #dddddd' }
        : {}}>{data.name}</div>
    } else if (_.size(data) === 1) return <span>{currentOrg.name}</span>
  };

  const treeNodeDisable = (nodes: TreeSelectData[]) => {
    return nodes?.map(node => {
      const newNode = { ...node };
      if (newNode.id.includes('Null_')) {
        newNode.disabled = true;
      }
      if (newNode.subs && newNode.subs.length > 0) {
        newNode.subs = treeNodeDisable(newNode.subs);
      }
      return newNode;
    });
  }

  const dropdownRender = (menu: React.ReactElement) => {
    return (
      <>
        {menu}
        {hasPermission(currentUser, [UserPermissionEnum.ORG_ADD]) &&
          <div onClick={() => setOpenAddOrg(true)} style={{ margin: '8px 0', backgroundColor: '#f5f5f5', cursor: 'pointer' }}>
            <PlusCircleOutlined style={{ color: '#1890ff', fontSize: 16, margin: '0 4px' }} />
            <span>{t('org.addOrg')}</span>
          </div>
        }
      </>
    )
  }

  const filterMenuHavePer = (menuItems: NavTitle[]): NavTitle[] => {
    return menuItems.reduce((filtered: NavTitle[], item: NavTitle) => {
      const newItem = { ...item };
      if (item.hasPermission) {
        if (Array.isArray(item.children) && item.children.length > 0) {
          newItem.children = filterMenuHavePer(item.children);
          if (newItem.children.length > 0) {
            filtered.push(newItem);
          }
        } else {
          filtered.push(newItem);
        }
      }
      return filtered;
    }, []);
  }

  const buildMenuItems = (items: NavTitle[]): MenuProps['items'] => {
    const list = items.map((it) => {
      if (!it) return null;
      if (it.children && it.children.length > 0) {
        return {
          key: it.key,
          label: <SText text={it.label} style={{ color: 'white' }} placement='right' />,
          children: buildMenuItems(it.children),
        };
      }
      return {
        key: it.key,
        label: <SText text={it.label} style={{ color: 'white' }} placement='right' />,
      };
    });
    return list.filter(Boolean) as MenuProps['items'];
  };

  return (
    <LayoutWrap style={{ height: "100vh", overflow: "hidden" }}>
      <Sider>
        <div className="header-logo-text">
          <span className="left">
            {(window as unknown as CustomWindow).config.server_name}
          </span>
          <span className="right">
            <Locale />
          </span>
        </div>
        <div className="scrollable-menu">
          <Menu
            theme="dark"
            openKeys={menuOpenKeys}
            defaultSelectedKeys={[ROUTER_KEYS.SALES_CUSTOMER]}
            selectedKeys={[menuSelectKeys]}
            mode="inline"
            onOpenChange={(keys) => setMenuOpenKeys(keys)}
            items={buildMenuItems(filterMenuHavePer(menuNavTitles))}
            onClick={({ key }) => navigate(String(key))}
          />
        </div>
        <div className="user-operate">
          <SOrgSelect
            allowClear={false}
            value={selectValue}
            dropdownRender={dropdownRender}
            treeData={treeNodeDisable(orgs)}
            treeTitleRender={treeTitleRender}
            onChange={treeSelectChange}
            style={{ width: '74%' }}
          />
          <Dropdown
            overlayStyle={{ minWidth: 100 }}
            trigger={["click"]}
            menu={{ items: profileItems }}
            placement='topRight'
            onOpenChange={(open) => setIsTooltipOpen(open)}
          >
            <WMSAvatar
              alt={getUserAvatarTip(currentUser)}
              uniChar={currentUser.id}
              avatarId={currentUser.avatar}
              creator={currentUser}
              tooltip={!isTooltipOpen}
              style={{ cursor: 'pointer', marginLeft: 4 }}
            />
          </Dropdown>
        </div>
        {/* <div className="header-bot-exit-text" onClick={exitLoginHandle}><Button type="link" block style={{ color: '#fff' }}>{t('layout.logout')}</Button></div> */}
      </Sider>
      <Layout>
        <OrgsContext.Provider
          value={{
            curOrg: currentOrg,
            orgsActions: [orgs, actions],
            setCurOrg: () => { },
          }}
        >
          <Content
            style={{
              margin: "0 16px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: 24,
                flex: 1,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                overflow: 'hidden',
              }}
            >
              {isUserInfo && (
                <UserDetailEdit
                  onCancel={() => {
                    setIsUserInfo(false);
                  }}
                  userInfo={currentUser}
                  openStatus={true}
                />
              )}
              <Outlet key={keyPath.length > 0 ? keyPath[0].title : ""} />
            </div>
          </Content>
        </OrgsContext.Provider>
      </Layout>
      {openAddOrg && <OrgAddModal
        open={openAddOrg}
        onOk={(info) => {
          add(info);
          notification.success({ placement: 'top', message: t('org.addSuccess') });
          setOpenAddOrg(false);
        }}
        onCancel={() => setOpenAddOrg(false)}
      />}
      <Modal
        title={t('layout.preferences')} className="fullScreen" open={isModalOpen}
        width={800} maskClosable={false}
        onCancel={() => {
          setIsModalOpen(false)
          setActiveKey('1')
        }}
        footer={['4', '5', '6', '7'].includes(activeKey) ? null : <Button type='primary' onClick={submit}>{t('layout.submit')}</Button>}
        destroyOnClose={true}
      >
        <hr />
        <Spin spinning={loading && !['5', '6'].includes(activeKey)}>
          <Tabs
            tabPosition={'left'}
            items={tabList}
            onChange={(key) => { setActiveKey(key) }}
          />
        </Spin>
      </Modal>
    </LayoutWrap>
  );
};

export default HomeLayout;
